import React from "react";
import "./sema-section-box.scss";
import EasyButton from "../../components/easy-button";
interface SemaSectionBoxProps {
    imageSource: any;
    boxTitle: string;
    buttonTitle: string;
    summaryDescription: any;
    boxNumber: number;
    onClickSectionBox: Function;
}

interface SemaSectionBoxState {

}

class SemaSectionBox extends React.Component<SemaSectionBoxProps, SemaSectionBoxState>{
    constructor(props: any) {
        super(props);
    }

    onClickHandler = () => {
        if (this.props.onClickSectionBox) {
            this.props.onClickSectionBox(this.props.boxNumber)
        }
    }

    render() {
        return (
            <div className="sema-section-box">
                <div className="section-box__name">{this.props.boxTitle}</div>

                <div className="section-box__image">
                    <img src={this.props.imageSource} alt={this.props.boxTitle} />
                </div>

                <div className="section-box__summary-description">
                    {this.props.summaryDescription}
                </div>
                <EasyButton title={this.props.buttonTitle} onClick={this.onClickHandler} />
            </div>
        )
    }
}

export default SemaSectionBox;